<template>
  <Modal :title="newOperationsTitle" @backdrop-click="closeModal">
    <template slot="body">
      <div>
        <BarcodeReaderModal
          v-if="openedModals.barcodeReader"
          @close="closeBarcodeReader"
        />
        <SearchCriterionsModal
          v-if="openedModals.criterions"
          :default-table-name="currentTable"
          @on-entity-select="setCurrentTable"
          @on-criterion-select="updateSearchResults('')"
          @close="openedModals.criterions = false"
        />
        <GeneralDescriptionModal
          v-if="openedModals.generalDescription"
          @close="openedModals.generalDescription = false"
        />
        <AddingItemModal
          v-if="openedModals.addingItem"
          :item="addingItem"
          :new-operations-list="newOperationsList"
          :current-operation="selectedOperationType"
          @close="hideAddingItem"
          @add="(item) => handleNewOperation(item, 'add')"
          @edit="(item) => handleNewOperation(item, 'edit')"
        />
        <Tabs :class="tabsCss" @select-tab="updateSearchResults">
        <Tab :title="newOperationsTitle">
            <div v-if="newOperationsList.length > 0">
              <div class="table-responsive table-responsive_long-list vert-scroll">
                <table class="table">
                <thead>
                  <tr>
                    <th
                      v-for="column in columnNames.addedItems"
                      :key="column"
                      class="list__column"
                    >
                      {{ column }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in newOperationsList"
                    :key="index"
                    class="row__container"
                  >
                    <td class="list__row">
                      {{ getRow(item.name, 20) }}
                    </td>
                    <td class="list__row">
                      {{ getRow(item.type, 20) }}
                    </td>
                    <td class="list__row">
                      {{ item.count }}
                    </td>
                    <td class="list__row">
                      {{ isParent(item) }}
                    </td>
                    <td class="list__row">
                      <router-link :to="getLinkByType(item)" target="_blank">
                        <i class="fa fa-link" />
                      </router-link>
                    </td>
                    <td class="list__row">
                      <i
                        class="fa fa-edit list__icon_add"
                        @click="showAddingItem(item, 'editing')"
                      />
                    </td>
                    <td class="list__row">
                      <i
                        class="fa fa-remove list__icon_add"
                        @click="handleNewOperation(item, 'remove')"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <div class="body__buttons">
                <div class="body__button_confirm-operations">
                  <button
                    class="btn btn-success"
                    :disabled="wasSubmitted"
                    @click="confirmOperationsFromList">
                      <i class="fa fa-check" />
                      Подтвердить
                  </button>
                </div>
                <div>
                  <button
                    class="btn btn-warning btn-md"
                    :disabled="wasSubmitted"
                    @click="openedModals.generalDescription = true"
                  >
                    <i class="fa fa-sticky-note-o fa-fw" />
                    Общее описание
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="body__results_is-empty">
              <p>Ещё ничего не добавлено</p>
              <div class="body__button_general-description">
                <button
                  class="btn btn-warning btn-md"
                  @click="openedModals.generalDescription = true"
                >
                  <i class="fa fa-sticky-note-o fa-fw" />
                  Общее описание
                </button>
              </div>
            </div>
          </Tab>
          <Tab title="Склад">
            <form @submit.prevent="() => startSearch(title)">
              <div class="input-group custom-search-form">
                <input
                  maxlength="50"
                  v-model="searchValue"
                  type="text"
                  class="form-control"
                  :placeholder="searchPlaceholder"
                />
                <span class="input-group-btn">
                  <button
                    v-if="wasSent"
                    class="btn btn-default btn-danger"
                    type="button"
                    @click="clearSearchData"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                  <button
                    v-if="searchCriterion === 'barcode'"
                    class="btn btn-default btn-primary"
                    type="button"
                    @click="openedModals.barcodeReader = true"
                  >
                    <i class="fa fa-barcode"></i>
                  </button>
                  <button
                    class="btn btn-default btn-primary"
                    type="submit"
                    :disabled="!searchValue"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
            </form>
            <Preloader v-if="isLoadingNow" type="small" />
            <div v-if="searchResults.length > 0 && !isLoadingNow && wasSent">
              <div class="body__header body__header_results">
                <label>Результаты поиска</label>
                <span>
                  Найдено записей: {{totalRecords}}
                </span>
              </div>
              <div class="table-responsive table-responsive_long-list vert-scroll">
                <table class="table">
                <thead>
                  <tr>
                    <th
                      v-for="name in columnNames.search"
                      :key="name"
                      class="list__column"
                    >
                      {{ name }}
                    </th>
                    <th v-if="currentTable === 'all'" class="list__column">
                      Сущность
                    </th>
                    <th v-if="entityCanBeParent" class="list__column">
                      Родитель
                    </th>
                    <th class="list__column">Ссылка</th>
                    <th class="list__column">Добавить</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in searchResults"
                    :key="index"
                    class="row__container"
                  >
                    <td class="list__row">
                      {{ getRow(item.name, 20) }}
                    </td>
                    <td class="list__row">
                      {{ getRow(item.type, 20) }}
                    </td>
                    <td class="list__row">
                      {{ getRow(item.barcode, 20) }}
                    </td>
                    <td class="list__row">
                      {{ getRow(item.vendor_code, 20) }}
                    </td>
                    <td v-if="currentTable === 'all'" class="list__row">
                      {{ getTranslatedEntity(item) }}
                    </td>
                    <td v-if="entityCanBeParent" class="list__row">
                      {{ isParent(item) }}
                    </td>
                    <td class="list__row">
                      <router-link :to="getLinkByEntity(item)" target="_blank">
                        <i class="fa fa-link" />
                      </router-link>
                    </td>
                    <td class="list__row">
                      <i
                        class="fa fa-plus-circle list__icon_add"
                        @click="showAddingItem(item)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
            <div v-if="!wasSent" class="body__results_before-query">
              <p>
                Пожалуйста, введите поисковый запрос
              </p>
            </div>
            <div v-if="!isLoadingNow && searchResults.length < 1 && wasSent" class="body__results_is-empty">
              <p class="results__text">
                Совпадений не найдено. Возможно, компонента нет в базе
              </p>
              <div class="results__button_new-item">
                <button v-if="currentTable !== 'all'" class="btn btn-success" @click="goToNewItemForm">
                  Добавить
                  <i class="fa fa-plus-circle"></i>
                </button>
              </div>
            </div>
            <div v-if="wasSent && searchResults.length > 0" class="tab__pagination">
              <Pagination
                :pages-counter="pagesCounter"
                :current-page="currentPage"
                :disabled="isLoadingNow"
                @select="(page) => updateSearchResults(title, page)"
              />
            </div>
          </Tab>
        </Tabs>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            class="btn btn-danger buttons__button_close-modal"
            :disabled="wasSubmitted"
            @click="closeModal"
          >
            Закрыть
          </button>
        </div>
        <div>
          <button
            class="btn btn-default btn-warning"
            type="button"
            @click="openedModals.criterions = true"
          >
            <i class="fa fa-gear"></i>
            Параметры
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
import Tabs from "@/_shared/components/ui/Tabs";
import Tab from "@/_shared/components/ui/Tab";
import Pagination from "@/_shared/components/ui/Pagination";
import Preloader from "@/_shared/components/ui/Preloader";

import AddingItemModal from "@/stock/widgets/new-operations/AddingItemModal";
import GeneralDescriptionModal from "@/stock/widgets/new-operations/GeneralDescriptionModal";
import SearchCriterionsModal from "@/stock/widgets/new-operations/SearchCriterionsModal";
import BarcodeReaderModal from "@/stock/widgets/barcode/ReaderModal";

import store from "@/stock/store";
import { objectHelper } from '@/_shared/utils';
import { itemsSearch, stockMovement } from "@/stock/constants";
import { itemsSearchService, operationService } from "@/stock/api-services";
import { usePagination, useNotification, useTableHelper } from "@/_shared/mixins";
export default {
  mixins: [
    usePagination,
    useNotification,
    useTableHelper,
  ],
  components: {
    Modal,
    Tabs,
    Tab,
    Pagination,
    Preloader,
    AddingItemModal,
    GeneralDescriptionModal,
    SearchCriterionsModal,
    BarcodeReaderModal,
  },
  emits: ["close"],
  data() {
    return {
      currentTable: 'all',
      isLoadingNow: false,
      notificationGroup: 'modal',
      totalRecords: 0,
      addingItem: {},
      openedModals: {
        criterions: false,
        generalDescription: false,
        addingItem: false,
        barcodeReader: false,
      },
      tabIsChanging: false,
      wasSent: false,
      wasSubmitted: false,
      columnNames: {
        addedItems: ["Название", "Тип", "Кол-во", "Родитель", "Ссылка", "Изменить", "Удалить"],
        search: ["Название", "Тип", "Штрихкод", "Артикул"],
      },
      searchValue: "",
      searchResults: [],
      tabTitles: itemsSearch.tabTitles.isSuccessful,
      possibleOperations: stockMovement.operationTypes,
    };
  },
  computed: {
    entityCanBeParent() {
      const entitiesList = ['all', 'products'];
      const results = entitiesList.includes(this.currentTable);
      return results;
    },
    searchCriterion() {
      return store.state.newOperations.searchCriterion;
    },
    selectedOperationType() {
      return store.state.newOperations.operationType;
    },
    newOperationsList() {
      return store.state.newOperations.list;
    },
    newOperationsTitle() {
      const currentOperation = this.possibleOperations[this.selectedOperationType];
      const title = `Новые ${currentOperation.toLowerCase()}`;
      return title;
    },
    tabsCss() {
      return {
        body__tabs_disabled: this.tabIsChanging,
      };
    },
    searchPlaceholder() {
      return itemsSearch.placeholders[this.searchCriterion];
    },
    searchButtonWasDisabled() {
      return !!(
        this.searchValue.length === 0 || this.searchCriterion === "off"
      );
    },
    searchFilter() {
      return {
        criterion: this.searchCriterion,
        query: this.searchValue,
      };
    },
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  methods: {
    isParent(item) {
      if (typeof item.parent_id === 'undefined') {
        return '✖';
      }
      return !!(item.parent_id === null) ? '✓' : '✖';
    },
    setCurrentTable(value) {
      this.currentTable = value;
      this.updateSearchResults(1);
    },
    closeBarcodeReader(savingBarcode = '') {
      this.searchValue = savingBarcode;
      this.openedModals.barcodeReader = false;
    },
    getTranslatedEntity(item) {
      const { entity } = item;
      const key = `${entity}_id`;
      const result = stockMovement.entity.byForeignKey[key];
      return result;
    },
    getLinkByType(item) {
      const types = {
        "ткань": "cloths",
        "фурнитура": "sewing_accessories",
        "канцелярия": "stationery",
        "расходник": "expendable_materials",
        "рекламная продукция": "promotional_products",
        "упаковка": "packages",
        "продукт": "products",
        "крой": "cut_of_clothes",
      };
      const link = `/${types[item.type]}/${item.id}`;
      return link;
    },
    getLinkByEntity(item) {
      let currentTable = this.currentTable;
      if (this.currentTable === 'all') {
        currentTable = stockMovement.tables[`${item.entity}_id`];
      }
      const link = `/${currentTable}/${item.id}`;
      return link;
    },
    handleNewOperation(item = null, action = 'add') {
      store.dispatch(`newOperations/${action}`, item);
    },
    async confirmOperationsFromList() {
      if (this.wasSubmitted) {
        return;
      }
      this.wasSubmitted = true;
      const preparedList = store.getters['newOperations/prepareListForApi'];
      const type = this.selectedOperationType;
      await operationService.confirm(preparedList, type).then((result) => {
        this.showSuccessNotification(result.message)
        setTimeout(() => {
          this.$router.go()
        }, 2500);
      })
      .catch(({ response }) => {
        this.showErrorNotification(response.data.message)
        setTimeout(() => {
          this.wasSubmitted = false;
        }, 1800);
      });
    },
    showAddingItem(item, operationType = 'adding') {
      const { createCopy } = objectHelper;
      this.addingItem = createCopy(item);
      if (operationType === 'adding' && this.currentTable === 'all') {
        const key = `${item.entity}_id`;
        this.addingItem.type = stockMovement.entity.byForeignKey[key];
      }
      if (operationType === 'adding' && this.currentTable !== 'all') {
        const table = this.currentTable;
        this.addingItem.type = stockMovement.entity.byTable[table];
      }
      this.openedModals.addingItem = true;
    },
    hideAddingItem() {
      document.querySelector('body').style.overflow = 'hidden';
      this.addingItem = null;
      this.openedModals.addingItem = false;
    },
    goToNewItemForm() {
      const routeData = this.$router.resolve(`/${this.currentTable}/new`);
      window.open(routeData.href, '_blank');
    },
    closeModal() {
      if (!this.wasSubmitted) {
        this.clearSearchData();
        store.dispatch('newOperations/clear');
        document.querySelector('body').style.overflow = 'auto';
        this.$emit("close");
      }
    },
    clearInput() {
      this.searchValue = "";
    },
    clearSearchData() {
      this.searchValue = "";
      this.searchResults = [];
      this.wasSent = false;
      this.tabTitles = itemsSearch.tabTitles.isSuccessful;
    },
    async startSearch(title) {
      this.wasSent = true;
      await this.updateSearchResults(title);
    },
    async updateSearchResults(tabTitle, page = 1) {
      if (!this.wasSent || this.isDeniedTab(tabTitle)) {
        return;
      }
      this.isLoadingNow = true;
      this.tabIsChanging = true;
      await itemsSearchService
        .perform(this.currentTable, { ...this.searchFilter, page })
        .then((response) => {
          const { results, pagesCounter, totalRecords } = response;
          this.searchResults = results;
          this.totalRecords = totalRecords;
          this.usePagination(page, pagesCounter, false);
          this.tabIsChanging = false;
          this.isLoadingNow = false;
        });
    },
    isDeniedTab(title) {
      const pattern = /Новые.*/i;
      return pattern.test(title);
    },
  },
};
</script>

<style scoped>
.body__results_is-empty {
  text-align: center;
  display: inline-flex;
  width: 100%;
  justify-content: center;
  padding: 5em 4em;
  flex-direction: column;
}

.body__header_results {
  display: flex;
  justify-content: space-between;
}

.results__button_new-item {
  margin-top: 1em;
  display: flex;
  justify-content: center;
}

.header__select_operation {
  margin-left: 1em;
}

.select__subtitle {
  font-weight: 700;
}

.body__header {
  display: flex;
  align-items: center;
  column-gap: 4em;
  padding: 1em 0;
}

.header__filters {
  display: flex;
  flex-direction: row;
}

.body__button_general-description {
  display: flex;
  justify-content: center;
}

.body__header_search-input {
  display: flex;
  flex-direction: column;
  row-gap: 1em;
  padding-bottom: 2em;
}

.body__header_search-input > label,
.body__header_search-input > div {
  width: 100%;
}

.body__buttons {
  display: inline-flex;
  flex-direction: row;
  margin-top: 1em;
  align-items: center;
}

.body__buttons > div:first-child {
  margin-right: 0.5em;
}

.body__input {
  margin-bottom: 1.5em 0;
  z-index: 9;
  display: flex;
  flex-direction: row;
  column-gap: 0.2em;
}

.body__tabs_disabled {
  pointer-events: none;
  opacity: 0.5;
}
.list__icon_add:hover,
.list__icon_add:focus {
  cursor: pointer;
  opacity: 0.6;
  transition: 0.3s;
}

.tab__pagination {
  margin-top: 1em;
}

.body__results_before-query {
  text-align: center;
  margin: 5em 0;
}

@media (max-width: 1023px) {
  .body__header_search-input {
    display: flex;
    flex-direction: column;
    row-gap: 1em;
    justify-content: flex-start;
  }
  .header__filters {
    flex-direction: column;
  }
}

@media (max-width: 767px) {
  .body__buttons {
    flex-direction: column;
  }
  .body__buttons,
  .body__buttons > div,
  .body__buttons > div > button {
    width: 100%;
  }
  .body__buttons > div:first-child {
    margin-bottom: 1em;
  }
  .body__header {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/stock/components/NewOperationsModal.vue